// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__AVh-f","section":"Contact_section__JnKQs"};